import Input from './input';

export { default as inputVariants, type InputVariantProps } from './variants';
export { type InputProps } from './input';

export default Input;
